/**
 * Client-side timing for the `updateGenerator` callable.
 *
 * MUST equal `UPDATE_GENERATOR_TIMEOUT_SECONDS` in functions/src/projects/generatorApi.ts.
 * The two codebases share no module, so a server test reads this file and fails if the
 * numbers diverge. The server derives its value from a tested worst case (live AppSheet
 * status read + Edit + the SHARED writeback, with retries); the client must wait at
 * least that long or it reports "failed" for a save that is still running.
 */
export const UPDATE_GENERATOR_SERVER_TIMEOUT_SECONDS = 240;

/**
 * The server's timeout plus 10s for the network round trip and cold start. The Firebase
 * SDK default (70s) is far shorter than the server's budget.
 */
export const UPDATE_GENERATOR_CALLABLE_TIMEOUT_MS = UPDATE_GENERATOR_SERVER_TIMEOUT_SECONDS * 1000 + 10_000;

/**
 * Client-side timing for the `projects_setGeneratorWorkflowStatus` callable (Credit Hold and the other
 * status actions). MUST equal `SET_GENERATOR_WORKFLOW_STATUS_TIMEOUT_SECONDS` in
 * functions/src/projects/generatorStatusWorkflowService.ts; a server test reads this file. A Credit Hold pauses
 * the unit's recurring schedules in AppSheet one by one before it writes the status, so it can run for minutes.
 */
export const SET_GENERATOR_WORKFLOW_STATUS_SERVER_TIMEOUT_SECONDS = 540;
export const SET_GENERATOR_WORKFLOW_STATUS_CALLABLE_TIMEOUT_MS = SET_GENERATOR_WORKFLOW_STATUS_SERVER_TIMEOUT_SECONDS * 1000 + 10_000;
